module.exports = __webpack_public_path__ + "static/media/footer__facebook.a1ff6548.svg";